import { getLang } from '@/helpers/getLang'

export const getHeaderLogo = (dark = true) => {
    try {
        if (getLang()) {
            if (dark === true) {
                if (getLang() === 'ru') {
                    return '/logo-white-rus.svg'
                } else {
                    return '/logo-white-en.svg'
                }
            } else {
                if (getLang() === 'en') {
                    return '/logo-black-en.svg'
                } else {
                    return '/logo-black-rus.svg'
                }
            }
        } else {
            if (dark === true) {
                return '/logo-white-rus.svg'
            } else {
                return '/logo-black-rus.svg'
            }
        }
    } catch {
        return '/logo-white-rus.svg'
    }
}
